import React, { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import ClientsDropDown from "./ClientsDropDown";
import UsersDropDown from "./UsersDropDown";
import OrderDropDown from "./OrderDropDown";
import Classes from "./AddTicket.module.css";

const LeftArrow = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 448 512"><path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z" /></svg>
)

export default function AddTicket() {
    const navigateTo = useNavigate();
    const fileInputRef = useRef(null);

    // States
    const [selectedClient, setselectedClient] = useState(null);
    const [subject, setSubject] = useState("");
    const [message, setMessage] = useState("");
    const [files, setFiles] = useState([]);
    const [dragging, setDragging] = useState(false);

    const clients = [
        { id: 1, name: "John Smith", email: "johnsmith@gmail.com" },
        { id: 2, name: "Jane Doe", email: "janedoe@gmail.com" }
    ];

    const handleBackClick = () => navigateTo("/tickets");

    // File Drag & Drop Handlers
    const handleDragOver = (e) => {
        e.preventDefault();
        setDragging(true);
    };

    const handleDragLeave = () => {
        setDragging(false);
    };

    const handleDrop = (e) => {
        e.preventDefault();
        setDragging(false);
        const droppedFiles = Array.from(e.dataTransfer.files);
        setFiles((prevFiles) => [...prevFiles, ...droppedFiles]);
    };

    // File Input Change
    const handleFileChange = (e) => {
        setFiles((prevFiles) => [...prevFiles, ...Array.from(e.target.files)]);
    };

    // Trigger file input click when clicking "Browse"
    const handleBrowseClick = () => {
        fileInputRef.current.click();
    };

    // Form Submit Handler
    const handleSubmit = (e) => {
        e.preventDefault();
        console.log("Form Data:", {
            subject,
            message,
            selectedClient,
            files
        });
    };

    return (
        <div className={Classes.hero}>
            <div className={Classes.header}>
                <button onClick={handleBackClick} className={Classes.backButton}>
                    <LeftArrow height='13px' fill='#969696' />
                    <h5>Tickets</h5>
                </button>
            </div>
            <div className={Classes.hero2}>
                <h3>Add ticket</h3>

                <form onSubmit={handleSubmit}>
                    <div className={Classes.flexCol1}>
                        <label className={Classes.label}>Subject</label>
                        <input
                            type="text"
                            className={Classes.inputField}
                            placeholder="Enter subject"
                            value={subject}
                            onChange={(e) => setSubject(e.target.value)}
                        />
                    </div>

                    <div className={Classes.flexCol1}>
                        <label className={Classes.label}>Related Order</label>
                        <OrderDropDown
                            clients={clients}
                            selectedClient={selectedClient}
                            setselectedClient={setselectedClient}
                        />
                    </div>

                    <div className={Classes.flexCol1}>
                        <label className={Classes.label}>Message</label>
                        <textarea
                            rows="7"
                            className={Classes.inputField}
                            placeholder="Start typing..."
                            value={message}
                            onChange={(e) => setMessage(e.target.value)}
                            style={{ resize: "none" }}
                        ></textarea>
                    </div>
                    <div className="flexAlign10" >
                        <label className={Classes.label}>Upload files</label>
                        <div className='optionalText' > <h5>optional</h5> </div>
                    </div>
                    {/* File Upload Section */}
                    <div
                        className={`${Classes.fileUpload} ${dragging ? Classes.dragActive : ""}`}
                        onDragOver={handleDragOver}
                        onDragLeave={handleDragLeave}
                        onDrop={handleDrop}
                        onClick={handleBrowseClick} // Trigger file input on click
                    >
                        <input
                            type="file"
                            multiple
                            onChange={handleFileChange}
                            className={Classes.fileInput}
                            ref={fileInputRef} // Connect input ref
                        />
                        <h5>
                            <span className={Classes.browseText}>Browse</span> or drag and drop files here
                        </h5>
                    </div>

                    {/* File List Preview */}
                    {files.length > 0 && (
                        <ul className={Classes.fileList}>
                            {files.map((file, index) => (
                                <li key={index}>{file.name}</li>
                            ))}
                        </ul>
                    )}

                    <div className={Classes.flexEnd}>
                        <button type="submit" className={Classes.submitBtn}>
                            <h5>Add ticket</h5>
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}
